/* Shto buy box 2 (sections/shto-buy-box-2.liquid): photo slider, size cards with their own price, subscribe or one-time, quantity.
   A copy of shto-buy-box.js (Month 4, unchanged) with the size cards' prices following the purchase option.
   Adding to the cart is the theme's own product form (<form is="product-form">): it posts the form and opens the cart drawer. */
(function () {
  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var f = format || '${{amount}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, kind) {
      if (kind === 'amount_no_decimals') return withCommas;
      if (kind === 'amount_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
      if (kind === 'amount_no_decimals_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return withCommas + '.' + parts[1];
    });
  }

  function init(root) {
    if (root.shtoBB2) return;
    root.shtoBB2 = true;
    var q = function (sel) { return root.querySelector(sel); };
    var qa = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
    var format = root.getAttribute('data-money-format');
        var idInput = q('[data-bb-id]');
    var planInput = q('[data-bb-plan]');
    var qtyInput = q('[data-bb-qty-input]');
    var planSelect = q('[data-bb-plan-select]');
    var modeInputs = qa('[data-bb-mode]');
    var options = qa('[data-bb-option]');

    function variantFrom(el) {
      // data-plans: [[plan id, price, one-time price, saving %], ...] in cents.
      var plans = {};
      try { JSON.parse(el.getAttribute('data-plans') || '[]').forEach(function (a) { plans[String(a[0])] = { p: a[1], c: a[2], s: a[3] }; }); } catch (e) {}
      return {
        el: el,
        id: el.getAttribute('data-id'),
        key: el.getAttribute('data-key'),
        label: el.getAttribute('data-label') || '',
        available: el.getAttribute('data-available') === 'true',
        price: Number(el.getAttribute('data-price')),
        compare: Number(el.getAttribute('data-compare')) || 0,
        plans: plans
      };
    }
    var variants = options.map(variantFrom);
    var state = {
      variant: variants.filter(function (v) { return v.id === idInput.value; })[0] || variants[0],
      mode: planInput && !planInput.disabled ? 'subscribe' : 'once',
      plan: planSelect ? planSelect.value : null,
      qty: 1
    };

    // Photos: arrows loop, thumbnails pick, a swipe moves one photo (assets/shto-swipe.js).
    var track = q('[data-bb-track]');
    var current = 0;
    function visibleSlides() { return qa('[data-bb-slide]').filter(function (el) { return !el.hidden; }); }
    function visibleThumbs() { return qa('[data-bb-thumb]').filter(function (el) { return !el.hidden; }); }
    function markThumb(index) {
      current = index;
      var thumbs = visibleThumbs();
      thumbs.forEach(function (t, i) { if (i === index) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      var row = q('[data-bb-thumbs]'), t = thumbs[index];
      if (row && t && row.scrollWidth > row.clientWidth + 1) {
        var left = t.offsetLeft - thumbs[0].offsetLeft, right = left + t.offsetWidth;
        if (left < row.scrollLeft) row.scrollTo({ left: left, behavior: 'smooth' });
        else if (right > row.scrollLeft + row.clientWidth) row.scrollTo({ left: right - row.clientWidth, behavior: 'smooth' });
      }
    }
    function go(index, smooth) {
      var list = visibleSlides();
      if (!list.length || !track) return;
      index = (index + list.length) % list.length;
      markThumb(index);
      track.scrollTo({ left: list[index].offsetLeft - list[0].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    }
    qa('[data-bb-step]').forEach(function (btn) {
      btn.addEventListener('click', function () { go(current + Number(btn.getAttribute('data-bb-step')), true); });
    });
    qa('[data-bb-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () { go(visibleThumbs().indexOf(thumb), true); });
    });
    if (track) {
      track.addEventListener('scroll', function () {
        var list = visibleSlides();
        if (!list.length || !track.clientWidth) return;
        var index = Math.round(track.scrollLeft / track.clientWidth);
        if (index !== current && list[index]) markThumb(index);
      }, { passive: true });
    }
    // A photo set for one variant only shows while that variant is chosen.
    function showFor(key) {
      var changed = false;
      qa('[data-bb-slide], [data-bb-thumb]').forEach(function (el) {
        var f = el.getAttribute('data-bb-for');
        var hide = !!f && f !== key;
        if (el.hidden !== hide) { el.hidden = hide; changed = true; }
      });
      if (changed) go(0, false);
    }

    function setText(sel, text) { qa(sel).forEach(function (el) { el.textContent = text || ''; }); }
    function render() {
      var v = state.variant;
      if (!v) return;
      idInput.value = v.id;
      var alloc = v.plans && state.plan ? v.plans[state.plan] : null;
      var subscribe = state.mode === 'subscribe' && !!alloc;
      if (planInput) { planInput.value = state.plan || ''; planInput.disabled = !subscribe; }
      setText('[data-bb-percent]', (alloc ? alloc.s : 0) + '%');
      var shown = subscribe ? alloc.p : v.price;
      var compare = subscribe ? alloc.c : (v.compare > v.price ? v.compare : 0);
      setText('[data-bb-top-price]', money(shown, format));
      setText('[data-bb-top-compare]', compare ? money(compare, format) : '');
      qa('[data-bb-top-compare]').forEach(function (el) { el.hidden = !compare; });
      qa('[data-bb-top-save]').forEach(function (el) { el.hidden = !subscribe; });
      if (alloc) {
        setText('[data-bb-sub-compare]', money(alloc.c, format));
        setText('[data-bb-sub-price]', money(alloc.p, format));
      }
      setText('[data-bb-once-price]', money(v.price, format));
      // Each size card shows its own price for the chosen purchase option: the plan price with the one-time price crossed
      // out, or the one-time price alone.
      variants.forEach(function (o) {
        var a = o.plans && state.plan ? o.plans[state.plan] : null;
        var sub = state.mode === 'subscribe' && !!a;
        var price = sub ? a.p : o.price;
        var was = sub ? a.c : (o.compare > o.price ? o.compare : 0);
        var pe = o.el.querySelector('[data-bb-card-price]'), ce = o.el.querySelector('[data-bb-card-compare]');
        if (pe) pe.textContent = money(price, format);
        if (ce) { ce.textContent = was ? money(was, format) : ''; ce.hidden = !was; }
      });
      qa('[data-bb-card]').forEach(function (card) { card.setAttribute('data-selected', card.getAttribute('data-bb-card') === state.mode ? 'true' : 'false'); });
      modeInputs.forEach(function (input) { input.checked = input.value === state.mode; });
      options.forEach(function (btn) { btn.setAttribute('aria-pressed', btn === v.el ? 'true' : 'false'); });
            var submit = q('[data-bb-submit]');
      var label = q('[data-bb-submit-text]');
      if (submit) submit.disabled = !v.available;
      if (label) label.textContent = v.available ? label.getAttribute('data-add') : label.getAttribute('data-sold-out');
      qtyInput.value = state.qty;
      setText('[data-bb-qty-value]', String(state.qty));
      var minus = q('[data-bb-qty="-1"]');
      if (minus) minus.disabled = state.qty <= 1;
    }

    variants.forEach(function (v) {
      v.el.addEventListener('click', function () {
        if (!v.available || v === state.variant) return;
        state.variant = v;
        render();
        showFor(v.key);
      });
    });
    modeInputs.forEach(function (input) {
      input.addEventListener('change', function () { if (input.checked) { state.mode = input.value; render(); } });
    });
    qa('[data-bb-card]').forEach(function (card) {
      card.addEventListener('click', function (event) {
        if (event.target.closest('select, label')) return;
        state.mode = card.getAttribute('data-bb-card');
        render();
      });
    });
    if (planSelect) {
      planSelect.addEventListener('change', function () { state.plan = planSelect.value; state.mode = 'subscribe'; render(); });
    }
    qa('[data-bb-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.qty = Math.max(1, state.qty + Number(btn.getAttribute('data-bb-qty')));
        render();
      });
    });
    render();
  }
  function initAll() { document.querySelectorAll('[data-shto-bb2]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
